import React, { useRef, useState } from 'react';
import BabyGender from './BabyGender';
import FindButton from './FindButton';
import Search from './Search';
import SearchField from './SearchField';
import {
  FindButtonContainer,
  NameSearchButtons,
  NameStart,
  RectangularStrip,
  SearchNameSec,
} from './styled';

export default function SearchNameSection({ detailPage }) {
  const [selectedButton, setSelectedButton] = useState(0);
  const choosenGender = useRef(null);
  const enteredletter = useRef(null);
  const searchText = useRef();
  const buttonsData = ['NAME', 'ORIGIN'];
  const buttons = [];
  const selectedField = buttonsData[selectedButton].toLowerCase();
  buttonsData.map((data, index) => {
    buttons.push(
      <button
        className={selectedButton == index ? 'active' : ''}
        onClick={() => {
          onButtonClick(index);
        }}
        key={index}
      >
        {data}
      </button>,
    );
  });
  const onButtonClick = (index) => {
    setSelectedButton(index);
  };
  return (
    <SearchNameSec>
      <NameSearchButtons>{buttons}</NameSearchButtons>
      <Search
        searchText={searchText}
        field={selectedField}
        detailPage={detailPage}
      />
      <RectangularStrip />
      <BabyGender choosenGender={choosenGender} />
      <div>
        <NameStart>Name Starts with</NameStart>
        <SearchField setLetter={enteredletter} />
      </div>
      <FindButtonContainer>
        <FindButton
          name={enteredletter}
          gender={choosenGender}
          detailPage={detailPage}
        />
      </FindButtonContainer>
    </SearchNameSec>
  );
}
